<template>
  <div>
    <div class="modal fade show custom-modal" id="myModal" :class="{'modal-show':showModal}">
      <div class="modal-dialog modal-dialog-centered model-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" @click="$emit('closesharemodal')">&times;</button>
          </div>
          <div class="modal-body text-center pb-0">
            <p class="bold margin-style">{{pinNo? 'Are you sure you want to save the PIN?' : 'Are you sure you want to generate the PIN?'}}</p>
          </div>
          <div class="col-12 modal-footer pb-4">
            <div class="modal-footer">
              <button type="button" class="btn bgc-btn-secondary" data-dismiss="modal" @click="$emit('closesharemodal')">Cancel</button>
              <button
                type="button"
                class="btn bgc-btn-primary"
                @click="$emit('callsavepin')"
              >OK</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmationModal",
  components: {
    confirm
  },
  props: ['showModal','pinNo']
};
</script>

<style scoped>
h5 {
  font-weight: 600;
  color: #666666;
}
button.close {
  padding-top: 13px;
  text-align: right;
}
.modal-body {
  overflow-y: hidden;
  margin-top: -20px;
}
.modal-footer {
  border-top: 0 none;
  text-align: center;
  display: block;
}
.margin-style {
  margin-top: 30px;
}
.custom-modal{
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0,0,0,0.4);
  transform:scale(0);
}
.modal-show{
  display:block;
  transform:scaleY(0) scaleX(0);
  animation:unfoldIn 0.25s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
}
</style>